module.exports = __webpack_public_path__ + "static/media/c.9d9173bf.jpg";